import { useEffect } from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material";
import UsersTable from "./components/UsersTable";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Stack from "@mui/material/Stack";
import NewToast from "ui/atoms/NewToast";
import FormCard from "components/Forms/FormCard/FormCard";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getUsers, switchStatus } from "app/features/usersSlice";
import { changeStatusUser, hideToast } from "app/features/userSlice";
import LoaderCircular from "ui/atoms/LoaderCircular";
import { userChangeStatus } from "lib/helpers/userHelper";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import { User } from "types";
import withAuth from "lib/hoc/withAuth";

const Admin = () => {
  const dispatch = useAppDispatch();
  const { users } = useAppSelector((state) => state.users) ?? [];
  const { severity, response, showToast, error } = useAppSelector((state) => state.user) ?? [];

  const onChange = async (user: User) => {
    const userUpdated = userChangeStatus(user);
    dispatch(switchStatus(userUpdated));
    await dispatch(changeStatusUser(userUpdated));
  };

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  const onCloseToast = () => {
    dispatch(hideToast());
  };

  return (
    <>
      {response && (
        <NewToast open={showToast} setOpen={onCloseToast} severity={severity}>
          {getToastMessage(response, error)}
        </NewToast>
      )}
      <FormCard maxWidthCard={1150} maxWidthContainer='lg' title='Usuarios'>
        <Link to='/admin/user-create'>
          <ButtonWrapper direction='row' spacing={2}>
            <Button variant='outlined' startIcon={<AddIcon />}>
              Nuevo Usuario
            </Button>
          </ButtonWrapper>
        </Link>

        {users.length > 0 ? <UsersTable users={users || []} onChange={onChange} /> : <LoaderCircular />}
      </FormCard>
    </>
  );
};

export default withAuth(Admin);

const ButtonWrapper = styled(Stack)`
  margin: ${({ theme }) => theme.spacing(2, 3)};
`;
